<template>
    <div>
        <a-action-button @click="visible = true" icon="fluent:image-add-24-filled" intent="info"></a-action-button>

        <a-popup :visible="visible" @cancel="onCancel">
            <div class="tw-mx-auto tw-w-[95%] md:tw-max-w-[800px] tw-h-fit tw-overflow-auto tw-flex tw-flex-col tw-border tw-border-solid dark:tw-border-gray-400 tw-border-gray-300 tw-shadow-md tw-my-16 tw-rounded">
                <div class="tw-p-4 tw-text-lg tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-solid tw-font-semibold dark:tw-text-gray-700 tw-text-gray-500 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <span>{{ $t("Upload Image") }}</span>
                </div>

                <div class="tw-p-5 tw-bg-white tw-flex-1">
                    <form @submit.prevent="onSubmit">
                        <div class="tw-mb-4">
                            <FormFileUpload 
                                v-model="selectedFile"
                                :accept="'image/*'"
                                :label="$t('Select Image')"
                                :error="errors.image"
                                @change="onImageChange"
                            />
                        </div>

                        <div class="tw-flex tw-justify-end tw-gap-2">
                            <a-button intent="light" type="button" @click="onCancel" :disabled="loading">
                                {{ $t('Cancel') }}
                            </a-button>
                            <a-button type="submit" intent="primary" :loading="loading" :disabled="!selectedFile || !isImageChanged">
                                {{ $t('Upload Image') }}
                            </a-button>
                        </div>
                    </form>
                </div>
            </div>
        </a-popup>
    </div>
</template>

<script setup>
import { ref, defineProps, inject } from 'vue';
import FormFileUpload from '@/components/form/FormFileUpload.vue';
import { uploadImage } from '@/api/products';
import useAlert from '@/composables/useAlert';

const props = defineProps({
    item: {
        required: true
    }
})

const onUpdated = inject('onUpdated')
const visible = ref(false);
const selectedFile = ref(props.item.image_url);
const loading = ref(false);
const errors = ref({});
const isImageChanged = ref(false);

const onImageChange = () => {
    isImageChanged.value = true;
}


const onCancel = () => {
    visible.value = false;
    selectedFile.value = null;
    errors.value = {};
    loading.value = false;
};

const onSubmit = async () => {
    if (!selectedFile.value) return;

    loading.value = true;
    errors.value = {};

    try {
        // Use the uploadImage API function
        const res = await uploadImage(props.item.id, selectedFile.value);

        // Call updateSourcing to refresh the data
        const newProduct = {
            ...props.item,
            image_url: res.data.image_url
        }
        await onUpdated(newProduct);

        useAlert('Image updated successfully', 'success');

        onCancel(); // Close popup on success
    } catch (error) {
        console.error('Error uploading image:', error);
        errors.value = {
            image: error.response?.data?.message || 'Failed to upload image'
        };
    } finally {
        loading.value = false;
    }
};

// Remove the old watch since we don't need container ref anymore
</script>

<style></style>